function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from "react";
import { UnstyledIcon } from "../index";

var SpsButtonBase = function (_Component) {
  _inherits(SpsButtonBase, _Component);

  function SpsButtonBase() {
    _classCallCheck(this, SpsButtonBase);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  SpsButtonBase.prototype.render = function render() {
    var _props = this.props,
        disabled = _props.disabled,
        icon = _props.icon,
        preset = _props.preset,
        message = _props.message,
        spinning = _props.spinning,
        className = _props.className,
        type = _props.type,
        to = _props.to,
        href = _props.href,
        onClick = _props.onClick,
        activeClassName = _props.activeClassName,
        _props$exact = _props.exact,
        exact = _props$exact === undefined ? true : _props$exact,
        match = _props.match,
        staticContext = _props.staticContext,
        activeStyle = _props.activeStyle,
        style = _props.style,
        render = _props.render,
        history = _props.history,
        active = _props.active,
        props = _objectWithoutProperties(_props, ["disabled", "icon", "preset", "message", "spinning", "className", "type", "to", "href", "onClick", "activeClassName", "exact", "match", "staticContext", "activeStyle", "style", "render", "history", "active"]);

    var buttonTypes = {
      confirm: "sps-btn--confirm",
      default: "sps-btn--default",
      delete: "sps-btn--delete",
      key: "sps-btn--key",
      link: "sps-btn--link",
      icon: "sps-btn--icon",
      tabbed: "sps-tabbed-nav__nav-item"
    };

    var buttonClassName = "sps-btn";

    if (!preset) {
      throw new Error("Preset is a required field");
    }
    if (!buttonTypes[preset]) {
      throw new Error("Invalid preset");
    }

    if (!message && !icon) {
      throw new Error("Either message or icon property is required");
    }

    var buttonClass = " " + buttonTypes[preset];
    buttonClassName += buttonClass;

    if (spinning) {
      buttonClassName += " sps-btn--spinning";
    }

    if (disabled) {
      buttonClassName += " disabled";
    }

    if (active) {
      buttonClassName += " sps-tabbed-nav__nav-item--active";
    }

    if (className) {
      buttonClassName += " " + className;
    }

    var buttonIcon = typeof icon === "function" ? icon : function () {
      return React.createElement(UnstyledIcon, { className: icon });
    };

    var buttonProps = {
      props: this.props,
      buttonIcon: buttonIcon,
      className: buttonClassName
    };

    return React.createElement(
      Fragment,
      null,
      render(buttonProps)
    );
  };

  return SpsButtonBase;
}(Component);

export { SpsButtonBase as default };